import { Injectable } from '@angular/core';
import {
  ListPricingCodesQuery,
  ListPricingCodesResp,
  PricingCode,
  PricingWorkbenchApiService,
} from '@xpo-ltl/sdk-pricingworkbench';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PricingWorkbenchService {
  constructor(private pricingWorkBench: PricingWorkbenchApiService) {}

  requestPricingCodes(categories: any, subcategories: any): Observable<PricingCode[]> {
    const queryParams = new ListPricingCodesQuery();
    queryParams.category = categories;
    queryParams.subCategory = subcategories;
    return this.pricingWorkBench.listPricingCodes(queryParams).pipe(
      map((response: ListPricingCodesResp) => {
        return response.pricingCodes;
      })
    );
  }
}
